import type { IndexSignature } from "./Interfaces";
import { produce } from "immer";

export const checkKeyExists = <T>(keyToFind: string, object: IndexSignature<T>) => {
	return Object.keys(object).some((key) => key === keyToFind);
};

export const isEmptyString = (value: unknown): value is "" => {
	return typeof value === "string" && value.trim().length === 0;
};

export const isIndexibleObject = (value: unknown): value is Record<string, unknown> => {
	return !!value && typeof value === "object" && !Array.isArray(value);
};

export const sanitizeEmptyStrings = (object: Record<string, unknown>): Record<string, unknown> => {
	return produce(object, (draft) => {
		Object.entries(draft).forEach(([ key, value ]) => {
			if (value === null || value === undefined || isEmptyString(value)) {
				delete draft[ key ];
			} else if (isIndexibleObject(value)) {
				draft[ key ] = sanitizeEmptyStrings(value);
			}
		});
	});
};
